import { DataSource } from '@angular/cdk/collections';
import { Observable, BehaviorSubject } from 'rxjs';
import { InvoiceStatus, InvoiceModel } from './invoice-model';
import { PaymentService } from 'src/shared-app-portal/services/payment.service';
export class InvoicesDataSource implements DataSource<InvoiceModel> {
  invoices = new BehaviorSubject<InvoiceModel[]>([]);
  loading = new BehaviorSubject<boolean>(false);
  rowCount = new BehaviorSubject<number>(0);
  private _invoices: InvoiceModel[] = [];
  constructor(private paymentService: PaymentService) {}
  connect(): Observable<InvoiceModel[]> {
    return this.invoices.asObservable();
  }
  disconnect(): void {
    this.invoices.complete();
    this.loading.complete();
  }
  async loadPayments() {
    this.loading.next(true);
    this._invoices = [];

    this.setPayments(await this.paymentService.getInvoices());
  }

  setPayments(invoices: InvoiceModel[]) {
    this._invoices = invoices ?? [];
    this.invoices.next(this._invoices);
    this.rowCount.next(this._invoices.length);
    this.loading.next(false);
  }

  search = (value: string) => {
    if (value) {
      let searchResult = this._invoices
        .filter(
          (x) =>
            x.invoiceNumber?.toLowerCase().includes(value.toLowerCase()) ||
            x.orderNumber?.toLowerCase().includes(value.toLowerCase())
        )
        .slice();
      this.invoices.next(searchResult);
      this.rowCount.next(searchResult.length);
    } else {
      this.invoices.next(this._invoices);
      this.rowCount.next(this._invoices.length);
    }
  };

  filterByInvoiceStatus(invoiceStatus: string) {
    if (invoiceStatus) {
      let searchResult = this._invoices
        .filter((x) => InvoiceStatus[x.invoiceStatus.toString()] === invoiceStatus)
        .slice();
      this.invoices.next(searchResult);
      this.rowCount.next(searchResult.length);
    } else {
      this.invoices.next(this._invoices);
      this.rowCount.next(this._invoices.length);
    }
  }

  addToPayments(invoice: InvoiceModel) {
    if (!this._invoices.find((x) => x.id == invoice.id)) {
      this._invoices.unshift(invoice);
      this.invoices.next(this._invoices);
      this.rowCount.next(this._invoices.length);
    }
  }

  updateInvoice(invoice: InvoiceModel) {
    let index = this._invoices.findIndex((x) => x.id == invoice.id);
    if (index > -1) {
      this._invoices[index] = invoice;
      this.invoices.next(this._invoices);
    }
  }
}
